import { TFunction } from '@shared/types/types'
import { MAX_MESSAGE_CHARS } from '@shared/wallPost/constants'
import z from 'zod'
import { getRichTextLength } from './getRichTextLength'

export const createRichTextAreaSchema = (t: TFunction, maxLength: number = MAX_MESSAGE_CHARS) =>
  z.string().superRefine((value, ctx) => {
    const length = getRichTextLength(value)
    if (length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: t('Provide a message') })
    }
    if (maxLength !== undefined && maxLength !== null && length > maxLength) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t('Maximum {max} characters allowed', { max: maxLength.toLocaleString() }),
      })
    }
  })
